import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { selectAccessToken, selectUserRoles } from '@client/redux/user';
import { checkAuthorized } from './restrictUtils';

export function Restrict({
  children,
  permissions,
  userPermissions,
  isAuthenticated,
}) {
  const passedAuthorizedCheck = checkAuthorized(permissions, userPermissions);

  return (
    <Fragment>
      {children({
        isAuthorized: passedAuthorizedCheck,
        isAuthenticated,
      })}
    </Fragment>
  );
}

Restrict.propTypes = {
  children: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  permissions: PropTypes.arrayOf(PropTypes.string),
  featureFlags: PropTypes.arrayOf(PropTypes.string),
  userPermissions: ImmutablePropTypes.list,
};

Restrict.defaultProps = {
  permissions: [],
  featureFlags: [],
};

export function mapStateToProps(state) {
  const userRoles = selectUserRoles(state);
  return {
    isAuthenticated: !!selectAccessToken(state),
    userPermissions: selectUserRoles(state),
  };
}

export default connect(mapStateToProps)(Restrict);
